import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import "./LabelWithTooltip.css";

// Componente LabelWithTooltip que automáticamente muestra el ícono de interrogación si existe una descripción
const LabelWithTooltip = ({ htmlFor, children, description }) => {
  return (
    <label htmlFor={htmlFor} className="add-ave-form-label">
      {children}
      {description && (
        <span className="info-icon">
          <FontAwesomeIcon icon={faQuestionCircle} />
          <span className="tooltip-text">{description}</span>
        </span>
      )}
    </label>
  );
};

export default LabelWithTooltip;
